var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCohostzoneTileWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-dc-tpl": 156,
    id: "tile-white",
    viewBox: "0 0 120 120",
    "data-om-id": "a2af85af:161",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 157,
    x: 4,
    y: 4,
    width: 112,
    height: 112,
    rx: 26,
    fill: "#FFFFFF",
    "data-om-id": "a2af85af:162"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-dc-tpl": 158,
    transform: "translate(28 39.2) scale(0.8)",
    "data-om-id": "a2af85af:163"
  }, /*#__PURE__*/React.createElement("path", {
    "data-dc-tpl": 159,
    fill: "#000000",
    fillRule: "evenodd",
    d: "M24 4 A22 22 0 1 1 23.99 4 Z M24 15 A11 11 0 1 0 24.01 15 Z",
    "data-om-id": "a2af85af:164"
  }), /*#__PURE__*/React.createElement("path", {
    "data-dc-tpl": 160,
    fill: "#000000",
    d: "M44 22 H76 V38 H70 V30 H64 V38 H58 V30 H44 Z",
    "data-om-id": "a2af85af:165"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohostzoneTileWhite);
export default __webpack_public_path__ + "static/media/cohostzone-tile-white.f171c9e6c0f0a781cd27311bf22f76df.svg";
export { ForwardRef as ReactComponent };